<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/icons_for_book.jpg"/>
</div>
</div>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">All Is </span><span class="CharOverride-1">Calm</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-2">A Maine Christmas </span><span class="CharOverride-2">Reader </span></p>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer001">
</div>
</div>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-3">Edited by</span><span class="CharOverride-4"> Shannon Butler</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-5"><img alt="" class="_idGenObjectAttribute-2" src="image/ISLANDPRT_Horiz_BLKlogo.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// All_is_calm_interior_epub.vue?d8c375bc